module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "_1-CN ParaOverride-6",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "leading-139-5 CharOverride-11"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("hat is honour? A word. What is in that word ‘honour’? What is that ‘honour’? Air . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "EPG2_Epigraph_text_2_Full-out"
  }, [_vm._v("William Shakespeare, "), _c('br'), _c('span', {
    staticClass: "EPG2_Epigraph_text_2_Italic _idGenCharOverride-1"
  }, [_vm._v("Henry IV Part I")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25cebe9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBookVR02455.vue
// module id = 78
// module chunks = 0